import { Component } from '@angular/core';
import { MOBILE_CONTENT_NAVIGATION_ANIMATIONS } from './mobile-content-navigation.animations';
import { ContentNavigationService } from '@finder/shared/components/content-navigation/content-navigation.service';
import { CommonModule } from '@angular/common';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { ButtonComponent } from '../button/button.component';
import { PictureComponent } from '../picture/picture.component';
import { AnchorComponent } from '../anchor/anchor.component';
import { ClickScrollToDirective } from '@finder/shared/directives/click-scroll-to/click-scroll-to.directive';

@Component({
    selector: 'finder-mobile-content-navigation',
    templateUrl: './mobile-content-navigation.component.html',
    styleUrls: ['./mobile-content-navigation.component.scss'],
    animations: [...MOBILE_CONTENT_NAVIGATION_ANIMATIONS],
    imports: [
        CommonModule,
        FontIconComponent,
        ButtonComponent,
        PictureComponent,
        AnchorComponent,
        ClickScrollToDirective, // finderClickScrollTo
    ]
})
export class MobileContentNavigationComponent {

    links: any[] = [];
    activeLink: any;
    logo: any;
    cta: any;
    displayedList = false;
    ariaLabel: string;

    constructor(
        private contentNavigationService: ContentNavigationService,
    ) {}

    displayList() {
        this.displayedList = !this.displayedList;
    }

    handlePageAnchor(event, link) {
        // If this is not a page anchor then just be a normal link
        if (!link.pageAnchor) {
            return true;
        }

        // Do in-page anchor things
        this.contentNavigationService.setActiveLink(link, false, false);
        this.displayList();
    }
}
